import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import { Link } from 'react-router-dom';
import InputField from './Controls/Field';
import {
  validateEmail,
  validatePassword,
  validatePasswordChars,
} from './Validators';

const fields = [
  {
    model: '.email',
    RRFComp: Control.text,
    control: {
      placeholder: 'Email',
      type: 'email',
      errors: {
        required: val => !val || !val.length,
        isEmail: val => val && !validateEmail(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide your email address.',
        isEmail: val => `${val} is not a valid Email Address.`,
        inUse: (
          <span>
            Email is in use. <Link to="/login">Log in</Link> if this is your account.
          </span>),
      },
    },
  },
  {
    model: '.passphrase',
    RRFComp: Control.text,
    control: {
      type: 'password',
      placeholder: 'Password',
      errors: {
        required: val => !val || !val.length,
        length: val => val && !validatePassword(val),
        chars: val => val && !validatePasswordChars(val),
      },
    },
    error: {
      component: props => <div>{props.children}</div>,
      show: field => !field.pristine,
      messages: {
        required: 'Please enter a password.',
        length: 'Password must be at least 8 characters.',
        chars: 'Value must contain at least one uppercase letter, one lowercase letter, one number and one special character (!@#$%^&*).',
      },
    },
  },
  {
    model: '.verifyPassphrase',
    RRFComp: Control.text,
    control: {
      type: 'password',
      placeholder: 'Confirm Password',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please confirm your password.',
      },
    },
  },
];

const Address = ({ credentialsPath }) => (
  <Fieldset model={credentialsPath}>
    {fields.map(field => (<InputField key={field.model} fieldProps={field} />))}
  </Fieldset>
);

export default Address;




// WEBPACK FOOTER //
// ./src/components/Forms/Credentials.js